import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import SetupTagGroups from './components/SetupTagGroups';

const SetupTagGroupsBridge = react2angular(SetupTagGroups);
export default SetupTagGroupsBridge;
